import { RemiAvatar, RemiSeparator } from "@remi/next-ui";

import { usePersonProfilePhoto } from "~/hooks/usePerson";
import { ContactDrawerButton } from "./ContactDrawerButton";
import { OrganizationBadge } from "./OrganizationBadge";
import { StatusTags } from "./StatusTags";

type ContactHeaderProps = {
  personId: string;
  showButtons?: boolean;
};

export const ContactHeader = ({ personId, showButtons = true }: ContactHeaderProps) => {
  const { data: person } = usePersonProfilePhoto(personId);
  if (!person) {
    return null;
  }
  return (
    <div className="group/contact flex w-full items-center gap-2 p-4">
      <div className="shrink-0">
        <RemiAvatar size="md" person={person} url={person.profilePhotoUrl} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div className="flex w-full items-center gap-2">
          <span className="type-sm-emphasis truncate">{person.contact.name}</span>
          {showButtons && <ContactDrawerButton personId={personId} className="-ml-1 shrink-0" />}
          <OrganizationBadge personId={personId} multiline className="ml-auto shrink-0 bg-background-tertiary" />
        </div>
        <div className="flex w-full items-center gap-2">
          {person.jobTitle?.trim() && (
            <>
              <span className="type-xs min-w-0 truncate text-text-tertiary">{person.jobTitle}</span>
              <RemiSeparator orientation="vertical" className="h-4 shrink-0" />
            </>
          )}
          <StatusTags personId={personId} organizationId={person.organizationId} />
        </div>
      </div>
    </div>
  );
};
